/**
 * src/components/promos/PromosHeader.js
 *
 * Lado izquierdo de la sección: label, headline, descripción y CTA.
 * Props: { label, headline, description, cta: { label, href } }
 */

import { define } from '@components/Component.js'
import { h } from '@core/dom.js'

define('PromosHeader', ({ label, headline, description, cta }) => {
    return h('div', { className: 'promos-header' },
        h('span', { className: 'promos-header__label' }, label),
        h('h2',   { className: 'promos-header__headline' }, headline),
        h('p',    { className: 'promos-header__desc' }, description),
        h('a',    { className: 'promos-header__cta', href: cta.href }, cta.label)
    )
})
